import { render, staticRenderFns } from "./MenuUsuario.vue?vue&type=template&id=13952576&scoped=true"
import script from "./MenuUsuario.vue?vue&type=script&lang=js"
export * from "./MenuUsuario.vue?vue&type=script&lang=js"
import style0 from "./MenuUsuario.vue?vue&type=style&index=0&id=13952576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13952576",
  null
  
)

export default component.exports